import { RichTextFormatter } from '@manomano-internal/i18n';
import { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const {
  subscriptionLabel,
  subscriptionLabelWithSales,
  buttonLabel
} = translate({
  "subscriptionLabel": "Abonnement",
  "subscriptionLabelWithSales": "Promo",
  "buttonLabel": "D\xE9couvrir"
});
export const recruitmentTouchpointLabel = translateFormatter<{
  u: RichTextFormatter;
}>("Livraison <u>gratuite illimit\xE9e</u> \xE0 partir de 59\u20ACHT/mois", undefined, undefined, "en");
export const recruitmentTouchpointLabelWithVariablePrice = translateFormatter<{
  u: RichTextFormatter;
  price: string;
}>("Livraison <u>gratuite illimit\xE9e</u> \xE0 partir de {price} HT/mois", undefined, undefined, "en");